module.exports = __webpack_public_path__ + "static/images/pick-up-pin.2TPstuv.svg";